/*
 * @Author: lbh
 * @Date: 2025-05-23 09:52:36
 * @LastEditors: lbh
 * @LastEditTime: 2025-05-24 11:11:41
 * @Description: 支付方法
 */

import router from "@/router";
import K from "@/js/util/loca_key";
import util from "@/js/util/util";

const pay = {
  // * 前往支付頁的 前置方法
  toPayBefore(arg) {
    let { total, type, orderId, showTabbar, back } = arg;
    if (total == 0) {
      if (type == 1) {
        // * 外送
        // * 將首頁 定位到 我的訂單
        localStorage.setItem(K.menu_show_order(), "1");
        // * 返回首頁
        router.go(-1);
      } else if (type == 7) {
        // * 自取
        router.replace({
          name: "inviteCode",
          params: {
            arg: util.setQueryParams([orderId, showTabbar ? 4 : ""]),
          },
        });
      } else if (type == 6) {
        // * 固定碼
        router.replace({
          name: "autoCodeOrderDetail",
          params: {
            arg: util.setQueryParams([orderId]),
          },
        });
      }
    } else {
      typeof back == "function" && back();
    }
  },
};
export default {
  install(Vue) {
    Vue.prototype.$pay = pay;
  },
};
